import React from 'react';
import { Control } from 'react-hook-form';
import { CoreInput } from '../Form/InputAntForm';
import { Typography } from 'antd';

interface Props {
  control: Control;
  name?: string;
  className?: string;
  placeHolder?: string;
}

export const CoreInputSearch = (props: Props) => {
  const { control, name = 'search', className, placeHolder, ...restProps } = props;

  return (
    <div className={className}>
      <Typography>Search</Typography>
      <CoreInput control={control} name={name} placeholder={placeHolder} {...restProps} />
    </div>
  );
};
